<template>
<div class="navbar navbar-expand-lg navbar-light">
    <!-- <div class="text-center d-lg-none w-100">
        <button type="button" class="navbar-toggler dropdown-toggle" data-toggle="collapse" data-target="#navbar-footer">
            <i class="icon-unfold mr-2"></i>
            Footer
        </button>
    </div>

    <div class="navbar-collapse collapse" id="navbar-footer">
        <span class="navbar-text">
            &copy; 2022. Go Saas
        </span>
    </div> -->
</div>
</template>

<script>
export default {
    name: 'FooterContent',
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/layouts/web/template/FooterContent.vue